// src/plugins/onesignal.js
import { UsersMutations } from "../store/Storetypes";

export default {
  install(Vue, { store }) {
    if (typeof window === "undefined") return;

    Vue.prototype.$loadOneSignal = function () {
      return new Promise((resolve, reject) => {
        // Use an async IIFE inside the promise instead of async executor
        (async () => {
          try {
            // Check if already initialized
            if (window.OneSignal && window.OneSignal.initialized) {
              console.log("⚙️ OneSignal already initialized");
              return resolve(window.OneSignal);
            }

            // Load SDK if needed
            if (!window.OneSignal) {
              console.log("🧩 Loading OneSignal SDK...");
              await this.loadOneSignalSDK();
            }

            // Wait for OneSignal to be available
            await this.waitForOneSignal();

            console.log("🚀 Initializing OneSignal...");

            await window.OneSignal.init({
              appId: "7f722486-d4c9-4aaf-9729-fc4fd568f048",
              requiresUserPrivacyConsent: false,
              notifyButton: {
                enable: true
              },
              // Auto-prompt users for permission
              promptOptions: {
                slidedown: {
                  enabled: true, // Shows permission prompt automatically
                  autoPrompt: true,
                  timeDelay: 3, // Shows after 3 seconds
                  pageViews: 1 // Shows after 1 page view
                }
              }
            });

            console.log("✅ OneSignal initialized");

            // Set up subscription change listener
            window.OneSignal.User.PushSubscription.addEventListener('change', (subscription) => {
              const playerId = subscription.id;
              if (playerId) {
                console.log("🎯 Player ID updated:", playerId);
                store.commit(UsersMutations.SET_ONE_SIGNAL_PLAYER_ID, playerId);
              }
            });

            // Get current subscription
            const subscription = await window.OneSignal.User.PushSubscription.getId();
            if (subscription) {
              console.log("🎯 Current Player ID:", subscription);
              store.commit(UsersMutations.SET_ONE_SIGNAL_PLAYER_ID, subscription);
            }

            // Check permission and prompt if needed
            const permission = await window.OneSignal.Notifications.permission;
            console.log("🔔 Current permission:", permission);

            if (permission === "default") {
              console.log("📣 Asking for notification permission...");
              await window.OneSignal.Slidedown.promptPush();
            }

            window.OneSignal.initialized = true;
            resolve(window.OneSignal);

          } catch (error) {
            console.error("❌ OneSignal init failed:", error);
            reject(error);
          }
        })();
      });
    };

    // Helper function to load SDK
    Vue.prototype.loadOneSignalSDK = function () {
      return new Promise((resolve) => {
        if (document.getElementById("onesignal-sdk")) {
          return resolve();
        }

        const script = document.createElement("script");
        script.id = "onesignal-sdk";
        script.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js";
        script.defer = true;
        document.head.appendChild(script);
        script.onload = resolve;
      });
    };

    // Helper function to wait for OneSignal to be ready
    Vue.prototype.waitForOneSignal = function () {
      return new Promise((resolve) => {
        if (window.OneSignal) {
          return resolve();
        }

        window.OneSignalDeferred = window.OneSignalDeferred || [];
        window.OneSignalDeferred.push(() => {
          resolve();
        });
      });
    };
  },
};